import React from 'react';
export default function StarTrailSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="pet-svg">
      <style>{`
        @keyframes st-twinkle1 {
          0%, 100% { transform: scale(0.4) rotate(0deg); opacity: 0.2; }
          50% { transform: scale(1.1) rotate(15deg); opacity: 1; }
        }
        @keyframes st-twinkle2 {
          0%, 100% { transform: scale(0.5) rotate(-10deg); opacity: 0.3; }
          50% { transform: scale(1) rotate(10deg); opacity: 0.9; }
        }
        @keyframes st-twinkle3 {
          0%, 100% { transform: scale(0.3) rotate(5deg); opacity: 0.15; }
          50% { transform: scale(1.15) rotate(-12deg); opacity: 0.95; }
        }
        @keyframes st-glow {
          0%, 100% { opacity: 0.15; transform: scale(1); }
          50% { opacity: 0.4; transform: scale(1.3); }
        }
        .st-s1 { animation: st-twinkle1 1.8s ease-in-out infinite; }
        .st-s2 { animation: st-twinkle2 2.2s ease-in-out infinite 0.4s; }
        .st-s3 { animation: st-twinkle3 2.6s ease-in-out infinite 0.8s; }
        .st-s4 { animation: st-twinkle1 2.0s ease-in-out infinite 1.2s; }
        .st-s5 { animation: st-twinkle2 1.6s ease-in-out infinite 1.6s; }
        .st-s6 { animation: st-twinkle3 2.4s ease-in-out infinite 0.2s; }
        .st-g1 { animation: st-glow 1.8s ease-in-out infinite; }
        .st-g2 { animation: st-glow 2.2s ease-in-out infinite 0.4s; }
        .st-g3 { animation: st-glow 2.6s ease-in-out infinite 0.8s; }
        .st-g4 { animation: st-glow 2.0s ease-in-out infinite 1.2s; }
        .st-g5 { animation: st-glow 1.6s ease-in-out infinite 1.6s; }
        .st-g6 { animation: st-glow 2.4s ease-in-out infinite 0.2s; }
      `}</style>
      <defs>
        <linearGradient id="stGold1" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FFF176" />
          <stop offset="100%" stopColor="#FFD700" />
        </linearGradient>
        <linearGradient id="stGold2" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#FFE082" />
          <stop offset="100%" stopColor="#FFC107" />
        </linearGradient>
      </defs>

      {/* Star 1 - large, upper-left */}
      <circle className="st-g1" cx="10" cy="10" r="4" fill="#FFD700" opacity="0.2" style={{ transformOrigin: '10px 10px' }} />
      <g className="st-s1" style={{ transformOrigin: '10px 10px' }}>
        <polygon points="10,5 11.5,8.5 15,9 12.5,11.5 13,15 10,13 7,15 7.5,11.5 5,9 8.5,8.5"
          fill="url(#stGold1)" />
        <polygon points="10,6.5 11,8.8 13.5,9.2 11.7,11 12,13.5 10,12.3 8,13.5 8.3,11 6.5,9.2 9,8.8"
          fill="white" opacity="0.3" />
      </g>

      {/* Star 2 - medium, upper-right */}
      <circle className="st-g2" cx="30" cy="8" r="3.5" fill="#FFD700" opacity="0.2" style={{ transformOrigin: '30px 8px' }} />
      <g className="st-s2" style={{ transformOrigin: '30px 8px' }}>
        <polygon points="30,4 31.2,7 34,7.5 32,9.5 32.5,12.5 30,11 27.5,12.5 28,9.5 26,7.5 28.8,7"
          fill="url(#stGold2)" />
      </g>

      {/* Star 3 - small, center */}
      <circle className="st-g3" cx="20" cy="18" r="2.5" fill="#FFD700" opacity="0.2" style={{ transformOrigin: '20px 18px' }} />
      <g className="st-s3" style={{ transformOrigin: '20px 18px' }}>
        <polygon points="20,15 21,17 23,17.3 21.5,18.8 22,21 20,19.8 18,21 18.5,18.8 17,17.3 19,17"
          fill="url(#stGold1)" />
      </g>

      {/* Star 4 - tiny, lower-left */}
      <circle className="st-g4" cx="8" cy="28" r="2" fill="#FFD700" opacity="0.2" style={{ transformOrigin: '8px 28px' }} />
      <g className="st-s4" style={{ transformOrigin: '8px 28px' }}>
        <polygon points="8,26 8.7,27.5 10.2,27.7 9.2,28.7 9.4,30.2 8,29.4 6.6,30.2 6.8,28.7 5.8,27.7 7.3,27.5"
          fill="url(#stGold2)" />
      </g>

      {/* Star 5 - medium, right-center */}
      <circle className="st-g5" cx="33" cy="22" r="2.8" fill="#FFD700" opacity="0.2" style={{ transformOrigin: '33px 22px' }} />
      <g className="st-s5" style={{ transformOrigin: '33px 22px' }}>
        <polygon points="33,19 34,21.2 36.2,21.5 34.6,23 35,25.2 33,24 31,25.2 31.4,23 29.8,21.5 32,21.2"
          fill="url(#stGold1)" />
      </g>

      {/* Star 6 - tiny, lower-center */}
      <circle className="st-g6" cx="22" cy="32" r="1.8" fill="#FFD700" opacity="0.2" style={{ transformOrigin: '22px 32px' }} />
      <g className="st-s6" style={{ transformOrigin: '22px 32px' }}>
        <polygon points="22,30.2 22.6,31.4 23.8,31.6 23,32.4 23.2,33.6 22,33 20.8,33.6 21,32.4 20.2,31.6 21.4,31.4"
          fill="url(#stGold2)" />
      </g>
    </svg>
  );
}
